// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials__Cq6Hb","social":"socials__social__fwNF9","icon":"socials__icon__jsf4I","navOpen":"socials__navOpen__Py60B"};